// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorAiUsage = (client) => ({
    /**
     * `GET /vendor/ai-usage`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetAiUsageSummary
     * @source packages/medusa-plugin-ai-usage/src/api/vendor/ai-usage/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/ai-usage", { method: "GET", query, headers }),
    /**
     * `GET /vendor/ai-usage/events`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListAiUsageEvents
     * @source packages/medusa-plugin-ai-usage/src/api/vendor/ai-usage/events/route.ts
     */
    listEvents: (query, headers) => client.fetch("/vendor/ai-usage/events", { method: "GET", query, headers }),
});
//# sourceMappingURL=ai-usage.js.map